import React from 'react';
import { FooterSection, FooterDesc} from './style.js'


const Footer = ()=>{
  return(
    <FooterSection>
    <FooterDesc> copyright &copy; 2018 by Hamza Nabil design and presented Islam M. Abozeed 2024 </FooterDesc>
</FooterSection>

    )
  }




export default Footer;